// The 1 clock app code reads for time-based choices: Next up, Coming up, "Morning", "tonight", Day N
// (docs/data-model.md, section 12). Tests freeze it at the board day, 09:00 UK, in either of 2 ways:
// - Playwright's page.clock freezes Date itself, which this reads;
// - outside production builds, ?clock=2026-09-30T09:00:00%2B01:00 in the address, or
//   window.hubClock.freeze(...) in the console, holds it for the tab until hubClock.clear().
// Database rules use the database's own now(), so a frozen clock changes only what's drawn.
import { useEffect, useState } from 'react'
import { ENV } from './env.js'

const STORE = 'hub.clock'
const canFreeze = ENV.context !== 'production'
let frozen = null
const listeners = new Set()

function readStore() {
  try { return sessionStorage.getItem(STORE) } catch { return null }
}
function writeStore(value) {
  try { value ? sessionStorage.setItem(STORE, value) : sessionStorage.removeItem(STORE) } catch { /* private mode */ }
}

function set(value) {
  const ms = value == null ? null : new Date(value).getTime()
  frozen = Number.isFinite(ms) ? ms : null
  writeStore(frozen == null ? null : new Date(frozen).toISOString())
  listeners.forEach(fn => fn())
}

if (canFreeze && typeof window !== 'undefined') {
  const fromUrl = new URLSearchParams(window.location.search).get('clock')
  const stored = readStore()
  if (fromUrl) set(fromUrl)
  else if (stored) set(stored)
  window.hubClock = {
    freeze: value => set(value),
    clear: () => set(null),
    now: () => new Date(now()).toISOString(),
  }
}

export function now() {
  return frozen ?? Date.now()
}

export function isFrozen() {
  return frozen != null
}

// Re-renders every 30 seconds, so "tonight" and "Join opens" move on without a reload.
export function useNow(intervalMs = 30000) {
  const [, tick] = useState(0)
  useEffect(() => {
    const bump = () => tick(t => t + 1)
    listeners.add(bump)
    const id = setInterval(bump, intervalMs)
    return () => { listeners.delete(bump); clearInterval(id) }
  }, [intervalMs])
  return now()
}
